import hFormTable from './src/h-form-table'

hFormTable.install = function (Vue) {
  Vue.component(hFormTable.name, hFormTable);
};

export default hFormTable;